import PaletteProps from './PaletteProps';
import hexToRgba from '../utils/hexToRgba';

const palette: PaletteProps = {
  color1: {
    hex: '#000000',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color2: {
    hex: '#0000FF',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color3: {
    hex: '#333333',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color4: {
    hex: '#CCCCCC',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color5: {
    hex: '#FFFFFF',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color6: {
    hex: '#7ED321',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color7: {
    hex: '#FBBE0F',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color8: {
    hex: '#DD291E',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color9: {
    hex: '#F6F6F6',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color10: {
    hex: '#767676',
    get rgba() {
      return hexToRgba(this.hex);
    },
  },
  color11: {
    hex: '',
    get rgba() {
      return '';
    },
  },
  color12: {
    hex: '',
    get rgba() {
      return '';
    },
  },
  color13: {
    hex: '',
    get rgba() {
      return '';
    },
  },
  get headline() {
    return {
      hex: '',
    };
  },
  get text() {
    return {
      hex: '',
    };
  },
  get background() {
    return {
      hex: '',
    };
  },
  get backgroundAlternative() {
    return {
      hex: '',
    };
  },
  get backgroundInfo() {
    return {
      hex: '',
    };
  },
  get backgroundSuccess() {
    return {
      hex: '',
    };
  },
  get backgroundWarning() {
    return {
      hex: '',
    };
  },
  get backgroundError() {
    return {
      hex: '',
    };
  },
  get border() {
    return {
      hex: '',
    };
  },
  get icon() {
    return {
      hex: '',
    };
  },
  get cta() {
    return {
      hex: '',
    };
  },
  get inactive() {
    return {
      hex: '',
    };
  },
  get success() {
    return {
      hex: '',
    };
  },
  get warning() {
    return {
      hex: '',
    };
  },
  get error() {
    return {
      hex: '',
    };
  },
};

export default palette;
